export enum EstadosRnt {
	Pendiente = 1,
	Activo = 2,
	Rechazado = 3,
	SuspendidoVoluntariamente = 4,
	SuspendidoPorNoRenovar = 5,
	SuspendidoPorAutoridadCompetente = 6,
	CanceladoVoluntariamente = 7,
	CanceladoPorNoRenovar = 8,
	CanceladoPorAutoridadCompetente = 9,
	Anulado = 10,
	PendientePorRenovar = 11,
	SinEstado = 16
}
